import { render, staticRenderFns } from "./RiskLevelPicker.vue?vue&type=template&id=1877e27a&"
import script from "./RiskLevelPicker.vue?vue&type=script&lang=js&"
export * from "./RiskLevelPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports